import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video",
  "use": "icon-video-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-video\">\n    <path fill=\"currentColor\" d=\"M18,5.111l-5.333,3.556V5.111H2v9.778h10.667v-3.556L18,14.889V5.111z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol